import Swiper, { Navigation, Pagination } from 'swiper8';

(function ($) {    
    const swiper = new Swiper('.screens-slider', {
        modules: [Navigation, Pagination],
        freeMode: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        centeredSlidesBounds: true,
        spaceBetween: 16,
        slidesOffsetBefore: 24,
        slidesOffsetAfter: 24,
        enabled: true,
        direction: 'horizontal',
        fadeEffect: {
            crossFade: true
        },
        pagination: {
            el: '.slider-pagination',
            bulletClass: 'slider-pagination__bullet',
            bulletActiveClass: 'slider-pagination__bullet--active',
            clickable: true,
        },
        breakpoints: {
            680: {
                freeMode: false,
                slidesPerView: 3,
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
                enabled: false,
                spaceBetween: 16,
            },
            1056: {
                freeMode: false,
                slidesPerView: 3,
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
                enabled: false,
                spaceBetween: 48,
            }
        }
    });

})(window.jQuery);
